import {
  faArrowDown91,
  faArrowDownZA,
  faArrowUp19,
  faArrowUpAZ,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelPopoverMenuItem from '../../../voxel/PopoverMenu/VoxelPopoverMenuItem';
import { HeadCellImplementationProps } from '../KeywordTable/HeadCells/models';

export interface HeadCellSortOptionsProps extends HeadCellImplementationProps {}

const HeadCellSortOptions: React.FC<HeadCellSortOptionsProps> = ({ basicConfig, basicState }) => {
  if (!basicConfig.showSorting) return null;

  return (
    <>
      <VoxelPopoverMenuItem
        icon={
          <FontAwesomeIcon icon={basicConfig.sortingType === 'text' ? faArrowUpAZ : faArrowUp19} />
        }
        selected={basicState.sortDirectionState === 'asc'}
        title="Sort ascending"
        onClick={() => basicState.toggleSortDirection && basicState.toggleSortDirection('asc')}
        closePopoverOnClick={false}
      />
      <VoxelPopoverMenuItem
        icon={
          <FontAwesomeIcon
            icon={basicConfig.sortingType === 'text' ? faArrowDownZA : faArrowDown91}
          />
        }
        title="Sort descending"
        selected={basicState.sortDirectionState === 'desc'}
        onClick={() => basicState.toggleSortDirection && basicState.toggleSortDirection('desc')}
        closePopoverOnClick={false}
      />
    </>
  );
};

export default HeadCellSortOptions;
